function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DEFAULT_WX_UPLOAD_IMAGE_OPTIONS = {
  count: 9,
  // 默认9
  sizeType: ['original'],
  // 可以指定是原图还是压缩图，默认二者都有
  sourceType: ['album', 'camera'] // 可以指定来源是相册还是相机，默认二者都有

};
export var WKWechatImageUploader = /*#__PURE__*/function () {
  function WKWechatImageUploader() {}

  var _proto = WKWechatImageUploader.prototype;

  _proto.upload = function upload(_ref) {
    var _ref$options = _ref.options,
        options = _ref$options === void 0 ? {} : _ref$options,
        onProgress = _ref.onProgress;

    var wxUploadOptions = _extends({}, DEFAULT_WX_UPLOAD_IMAGE_OPTIONS, options);

    return new Promise( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
        var localIds, untouchedLocalIds, serverIds, uploadLocalFileToServer;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new Promise(function (resolve, _) {
                  wx.chooseImage(_extends({}, wxUploadOptions, {
                    success: function success(res) {
                      resolve(res.localIds);
                    },
                    fail: reject
                  }));
                });

              case 2:
                localIds = _context.sent;
                untouchedLocalIds = localIds.concat(); // 复制一份未修改的 localIds

                serverIds = []; // 上传本地图片，只能串行上传

                uploadLocalFileToServer = function uploadLocalFileToServer() {
                  var localId = localIds[0];
                  onProgress && onProgress();
                  wx.uploadImage({
                    localId: localId,
                    isShowProgressTips: !onProgress,
                    success: function success(res) {
                      serverIds.push(res.serverId);
                      localIds.shift();

                      if (localIds.length > 0) {
                        uploadLocalFileToServer();
                      } else {
                        resolve({
                          localIds: untouchedLocalIds,
                          serverIds: serverIds
                        });
                      }
                    },
                    fail: reject
                  });
                };

                uploadLocalFileToServer();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  };

  return WKWechatImageUploader;
}();


//////////////////
// WEBPACK FOOTER
// ./~/@weike/uploader/lib/esm/wechat.js
// module id = 593
// module chunks = 6